/**
 * Outcome of one Nutzdatendatei inside an `Abrechnungslauf`
 * (TM-9538 / #1519).
 *
 * - `PENDING` — the file is planned; nothing has been written.
 * - `SUCCESS` — ⚠ **the Nutzdatendatei was produced.** This is the observable
 *   boundary the whole run turns on: the Anspruchszeilen of a file that reached
 *   `SUCCESS` stay, for ever, because a produced file may already be on its way
 *   to the Kasse. Under route (i) a human copies it into dakota's directory and
 *   we never learn whether they did — so *„zugestellt"* is not a state this
 *   product can hold, and pretending otherwise would invite a retraction §302
 *   does not have.
 * - `SKIPPED` — the run was canceled or swept before this file was built.
 *   Nothing was written, so its Anspruchszeilen are deleted.
 * - `FAILED` — building this file raised. The other files of the same run are
 *   unaffected: one transaction per file, and a failure is not contagious.
 *
 * There is no `RETRY` and no resumption. A failed file is terminal; its Fälle
 * are free again and reappear as candidates in the next run.
 */
export var GkvBillingRunFileStatus;
(function (GkvBillingRunFileStatus) {
    GkvBillingRunFileStatus["PENDING"] = "pending";
    GkvBillingRunFileStatus["SUCCESS"] = "success";
    GkvBillingRunFileStatus["SKIPPED"] = "skipped";
    GkvBillingRunFileStatus["FAILED"] = "failed";
})(GkvBillingRunFileStatus || (GkvBillingRunFileStatus = {}));
//# sourceMappingURL=gkv-billing-run-file-status.enum.js.map